<template>
  <div class="category-page">
    <div class="detail-page__title">
      <div class="page-nav-wrapper">
        <span class="page-nav__item">
          <router-link to="/index" class="page-nav__item-a"> 首页 </router-link>
          /
        </span>
        <span class="page-nav__item">
          <router-link to="/topic" class="page-nav__item-a">
            专题专栏
          </router-link>
          /
        </span>
        <span class="page-nav__item">
          <span class="page-nav__item-a">
            {{ $route.query && $route.query.name }}
          </span>
        </span>
      </div>
    </div>

    <div class="" style="min-height: 400px" v-loading="loading">
      <div class="news-items" v-if="list && list.length">
        <!-- :class="{ active: i === 0 }" -->
        <router-link
          class="news-item"
          :to="{
            name: 'topic_detail',
            query: {
              id: item.article_id,
            },
          }"
          v-for="item in list"
          :key="item.article_id"
        >
          <div class="title z-line-1" :title="item.title">
            {{ item.title }}
          </div>
          <div class="subtitle">
            {{ item.resource || item.title }}
            <span class="addtime">{{ item.addtime | dayjs("year-date") }}</span>
          </div>
        </router-link>
      </div>
      <div v-if="list" style="text-align: center">
        <img src="images/no-date.png" v-if="!list.length" alt="" />
      </div>
      <div class="z-pagination" v-if="total">
        <el-pagination
          background
          @current-change="handleCurrentChange"
          :current-page.sync="current_page"
          :page-size.sync="per_page"
          layout="prev, pager, next"
          :total="total"
        >
        </el-pagination>
        <span class="z-pagination__total"> 共 {{ total }} 条 </span>
      </div>
    </div>
  </div>
</template>

<script>
import { getCategoryZhuantiPage } from "@/apis/topic";

export default {
  data() {
    return {
      //
      per_page: 10,
      current_page: 1,
      total: 0,
      list: null,
      loading: false,
    };
  },
  created() {
    this.getCategoryZhuantiPage(this.$route.query.id);
  },
  methods: {
    handleCurrentChange(page) {
      this.$emit("currentChange", page);
      this.getCategoryZhuantiPage(this.$route.query.id);
    },
    async getCategoryZhuantiPage(id) {
      this.loading = true;
      const { data } = await getCategoryZhuantiPage({
        cate_id: id,
        page: this.current_page,
        pagenum: this.per_page,
      });
      this.total = data.total;
      this.per_page = data.per_page;
      this.current_page = data.current_page;
      this.list = data.data || [];
      this.loading = false;
    },
  },
  computed: {
    matched() {
      return this.$route.matched;
    },
  },
};
</script>

<style lang="scss" scoped>
.category-page {
  width: 100%;
}
</style>
